import { ChangeDetectionStrategy, Component, computed, input, output, ViewEncapsulation } from "@angular/core";
import { IAirline } from "../../types/airline";
import { OpOnErrorSrc } from "../opOnErrorSrc/opOnErrorSrc.directive";
import { SelectModule, SelectChangeEvent } from "primeng/select";
import { FormsModule } from "@angular/forms";

@Component({
  selector: 'op-airline-selector',
  templateUrl: "./opAirlineSelector.view.html",
  styleUrl: "./opAirlineSelector.style.scss",
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    OpOnErrorSrc,
    SelectModule,
    FormsModule
  ]
})
export class OpAirlineSelector {

  public current = input.required<IAirline>();
  public airlines = input.required({ transform: (v: IAirline[]) => v.sort((a, b) => (a.name ?? '').localeCompare(b.name ?? '')) });
  public onChange = output<IAirline>();
  protected airlineModel = computed(() => this.current().id);

  protected change(newAirline: SelectChangeEvent) {
    const selectedId = newAirline.value;
    if (selectedId === this.current().id) return;

    const selected = this.airlines().find(a => a.id === selectedId);
    if (selected) {
      this.onChange.emit(selected);
    }
  }
}
